import * as React from 'react'

import type { TrackingProperties } from 'modules/core/lib/Tracking'

import FieldModal from 'modules/custom_resources/components/CustomFields/FieldModal'

interface Props {
  allowedFieldTypes?: string[]
  allowPermissions?: boolean
  onClose: () => void
  onSubmit: (data: Record<string, unknown>) => Promise<void>
  paramsProcessor: Record<string, any>
  showAllowedFieldTypes?: boolean
  showRequired?: boolean
  trackingProperties?: TrackingProperties
}

const NewModal = ({
  allowedFieldTypes,
  allowPermissions,
  onClose,
  onSubmit,
  paramsProcessor,
  showAllowedFieldTypes,
  showRequired,
  trackingProperties,
}: Props) => {
  return (
    <FieldModal
      modalIllustration={paramsProcessor.get('modalIllustration')}
      modalTitle={paramsProcessor.get('modalTitle')}
      modalDescription={paramsProcessor.get('modalDescription')}
      modalPlaceholder={paramsProcessor.get('modalPlaceholder')}
      modalLabel={paramsProcessor.get('modalLabel')}
      modalButton={paramsProcessor.get('modalButton')}
      modalAlert={paramsProcessor.get('modalAlert')}
      allowedFieldTypes={allowedFieldTypes}
      allowPermissions={allowPermissions}
      showAllowedFieldTypes={showAllowedFieldTypes}
      showRequired={showRequired}
      onClose={onClose}
      onSubmit={onSubmit}
      trackingProperties={trackingProperties}
    />
  )
}

export default NewModal
